import { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';

import { toggleIsMobileMenuOpen } from 'store/features/navigationSlice';

import { MOBILE_BREAKPOINT } from 'constants/';

import { useAppDispatch, useAppSelector } from './redux';

export const useHideScroll = () => {
  const isMobileMenuOpen = useAppSelector((state) => state.navigation.isMobileMenuOpen);
  const isMobile = useMediaQuery({ query: MOBILE_BREAKPOINT });
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isMobile || !isMobileMenuOpen) {
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
      return;
    }

    const originalStyle = {
      overflow: document.body.style.overflow,
      touchAction: document.body.style.touchAction,
    };

    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';

    return () => {
      document.body.style.overflow = originalStyle.overflow;
      document.body.style.touchAction = originalStyle.touchAction;
    };
  }, [isMobileMenuOpen, isMobile]);

  useEffect(() => {
    if (!isMobile && isMobileMenuOpen) {
      dispatch(toggleIsMobileMenuOpen());
    }
  }, [isMobile, isMobileMenuOpen, dispatch]);
};
